import React, { useState } from 'react';
import IconSignInLogo from '../../components/icons/IconSignInLogo';
import { authenticate, $ } from '../../api';
import './index.css';

const SignIn = ({signIn}) => {
  const [isError, setIsError] = useState(false);
  const [isTouched, setIsTouched] = useState(false);
  const [formValues, setFormValues] = useState({
    email: '',
    password: ''
  });

  const updateFields = (e) => {
    setIsError(false);
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    });
  }

  const submit = async (e) => {
    e.preventDefault();
    const {email, password} = formValues;
    if (!email || !password) {
      return setIsError(true);
    }
    try {
      const { data } = await authenticate({email, password});
      if (data.status !== 'success') {
        throw new Error('Auth failed');
      }
      $.defaults.headers['x-auth'] = data.data.token;
      console.log(data);
      localStorage.setItem('role', data.data.role);
      localStorage.setItem('token', data.data.token);
      localStorage.setItem('userUUID', data.data.userUUID);
      signIn();
    } catch (e) {
      console.error(e);
      setIsError(true);
    }
  }

  return (
    <div className="sign-in__wrapper">
      <div className="sign-in__modal">
        <IconSignInLogo className="sign-in__logo"/>
        <h2 className="modal__title">Sign In</h2>
        <form className="sign-in__form" onSubmit={submit} onFocus={() => setIsTouched(true)}>
          <div className="sign-in__form-group">
            <label className="sign-in__form-label" htmlFor="email">Email</label>
            <input className="sign-in__form-input" id="email" type="text" value={formValues.email} name="email" onChange={updateFields}/>
          </div>
          <div className="sign-in__form-group">
            <label className="sign-in__form-label" htmlFor="password">Password</label>
            <input className="sign-in__form-input" id="password" type="password" password={formValues.password} name="password" onChange={updateFields}/>
          </div>
          {
            isError &&
            <div className="sign-in__form-group">
              <p className="sign-in__form-error">Email or password is not correct. Please contact administrator</p>
            </div>
          }
          <div className="sign-in__form-group">
            <input type="submit" value="Sign In" className="sign-in__form-submit btn btn--primary" disabled={isTouched && (isError || !formValues.email || !formValues.password)}/>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SignIn;